<div class="row head">
  <div class="image-container">
    <fa-icon [icon]="faCube"></fa-icon>
  </div>
  <div class="brand-container">
    <table>
      <tr>
        <th>{{ 'productDetails.bimTab.listItemBrand' | transloco }}</th>
        <td>{{ bimDocument.brand }}</td>
      </tr>
      <tr>
        <th>{{ 'productDetails.bimTab.listItemType' | transloco }}</th>
        <td>{{ bimDocument.brandType }}</td>
      </tr>
    </table>
  </div>
</div>
@for (file of bimDocument.bimFiles; track file) {
  <div class="row link">
    <a
      [href]="file.url"
      [type]="file.mimeType"
      class="btn btn-secondary"
      (click)="onDownload(file)"
    >
      <div class="image-container">
        <img
          [src]="'assets/images/bim/' + file.extension + '.png'"
          loading="lazy"
          [alt]="'file.extension'"
        />
      </div>
      <span>{{
        'productDetails.bimTab.listItemDownload'
          | transloco: { fileFormat: file.extension }
      }}</span>
      <fa-icon [icon]="faDownload"></fa-icon>
    </a>
  </div>
}
